export const BlockUserIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.99935 7.99871C9.84031 7.99871 11.3327 6.50632 11.3327 4.66537C11.3327 2.82442 9.84031 1.33203 7.99935 1.33203C6.1584 1.33203 4.66602 2.82442 4.66602 4.66537C4.66602 6.50632 6.1584 7.99871 7.99935 7.99871Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.27344 14.6667C2.27344 12.0867 4.84013 10 8.00013 10C8.64013 10 9.26014 10.0867 9.84014 10.2467"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6673 11.9987C14.6673 12.212 14.6407 12.4187 14.5873 12.6187C14.5273 12.8854 14.4206 13.1454 14.2806 13.372C13.8206 14.1454 12.974 14.6654 12.0007 14.6654C11.314 14.6654 10.694 14.4054 10.2273 13.9787C10.0273 13.8054 9.854 13.5987 9.72066 13.372C9.474 12.972 9.33398 12.4987 9.33398 11.9987C9.33398 11.2787 9.62065 10.6187 10.0873 10.1387C10.574 9.63871 11.254 9.33203 12.0007 9.33203C12.7873 9.33203 13.5006 9.67204 13.9806 10.2187C14.4073 10.692 14.6673 11.3187 14.6673 11.9987Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 10L10 14"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </svg>
  )
}
